import React, { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import debounce from 'lodash/debounce';
import { addQueryParams, removeQueryParams } from '@/Framework/Router/nextRouter';
import SearchInput from '@/Framework/UI/Molecules/Form/SearchInput';
import { useLeagueTableFiltersContext } from '@/finsight/application/League/Table/LeagueTableFiltersContext';

import styles from './leagueTablePage.scss';

const LeagueSearchInput = () => {
  const { push, query } = useRouter();
  const { q: currentTextSearch = '' } = query;
  const { state, setLeagueTableSearchState, resetLeagueTableSearchState } = useLeagueTableFiltersContext();
  const { value } = state.search;
  const onChangeDebounced = useCallback(debounce((value) => {
    const newQuery = value === '' ? removeQueryParams(query, ['q']) : addQueryParams(query, { q: value });

    setIsChange(false);
    push({ query: newQuery }, undefined, { scroll: false, shallow: true });
  }, 500), [query]);

  const [isChange, setIsChange] = useState(false);

  const onChange = ({ target }) => {
    const { value } = target;

    setLeagueTableSearchState(value);
    setIsChange(true);
    onChangeDebounced(value);
  };

  useEffect(() => () => {
    resetLeagueTableSearchState();
  }, []);

  // for tracking changes url when user press back or forward in the browser
  useEffect(() => {
    if (!isChange && currentTextSearch !== value) {
      setLeagueTableSearchState(currentTextSearch);
    }
  }, [currentTextSearch]);

  return (
    <SearchInput
      value={ value }
      name="searchLeague"
      isNarrow
      isClearable
      placeholder="Filter by Name and Abbreviation"
      inputClassName={ styles.searchInput }
      formFieldClassName={ styles.searchInputField }
      dataTest="formSearchInput"
      onChange={ onChange }
    />
  );
};

export default LeagueSearchInput;
